export const values = <T>(obj: Record<string, T>): T[] =>
  Object.keys(obj).map((key) => obj[key]);

export const getValue = (
  obj: Record<string, unknown> = {},
  path: string,
  defaultValue: unknown = undefined
): unknown => {
  if (!path.includes('.')) {
    return obj[path] || defaultValue;
  }

  let shouldBeDefault = false;
  return path.split('.').reduce<unknown>((acc, cur) => {
    if (shouldBeDefault) return defaultValue;

    const record = acc as Record<string, unknown>;
    const value = record[cur];

    if (typeof value === 'undefined') {
      shouldBeDefault = true;
      return defaultValue;
    }

    return value;
  }, obj);
};
